module.exports = "<img src=\"../../../assets/images/books.jpg\" alt=\"books\" class=\"img-fluid rounded img-responsive\">"